import AppStore from '../../stores/AppStore'
import type { ComposerMode } from '../../stores/types'

export const useComposerMode = (): ComposerMode => {
  const metaData = AppStore.getMetaData()

  if (metaData?.draftMode) {
    return 'edit-draft'
  }

  if (metaData?.editMode) {
    return 'edit-post'
  }

  return 'new-post'
}
